export default class AboutPage {
    constructor() {
        this.init();
    }

    init() {
        this.who();
        this.brand();
        this.initTechIntro();
        this.history();
        this.historyTrack();
    }

    who() {
        console.log("[AboutPage] who()");

        // 면도기 애니메이션
        const heroSection = document.querySelector(".no-about-hero");
        const sleekElement = document.querySelector(".no-about-hero__sleek");

        if (heroSection && sleekElement) {
            // 초기 상태: 면도기를 오른쪽 밖으로 이동 (기존 transform 유지하면서 x만 추가)
            gsap.set(sleekElement, {
                x: window.innerWidth * 0.5, // 화면 너비의 절반만큼 오른쪽으로 이동
                opacity: 0,
            });

            // ScrollTrigger 애니메이션
            gsap.to(sleekElement, {
                x: 0, // 원래 위치로 이동
                opacity: 1,
                duration: 1.2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: heroSection,
                    start: "top center",
                    end: "bottom center",
                    toggleActions: "play none none reverse",
                },
            });
        }

        // Swiper 초기화
        const innoSwiper = document.querySelector(".no-about-inno__swiper");
        if (!innoSwiper) return;

        new Swiper(innoSwiper, {
            slidesPerView: 6,
            spaceBetween: 20,
            scrollbar: {
                el: innoSwiper.querySelector(".no-about-inno__scrollbar"),
                draggable: true,
            },
            navigation: {
                nextEl: ".no-about-inno__button--next",
                prevEl: ".no-about-inno__button--prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.5,
                },
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4.5,
                },
                1280: {
                    slidesPerView: 6,
                },
            },
        });
    }

    brand() {
        console.log("[AboutPage] brand()");
        const brandSwiper = document.querySelector(
            ".no-brand-milestone__swiper"
        );
        if (!brandSwiper) return;

        new Swiper(brandSwiper, {
            slidesPerView: 6,
            spaceBetween: 20,
            scrollbar: {
                el: brandSwiper.querySelector(".no-brand-milestone__scrollbar"),
                draggable: true,
            },
            navigation: {
                nextEl: ".no-brand-milestone__button--next",
                prevEl: ".no-brand-milestone__button--prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.25,
                },
                768: {
                    slidesPerView: 1.75,
                },
                1024: {
                    slidesPerView: 2.25,
                },
                1280: {
                    slidesPerView: 3,
                },
            },
        });

        this.initWordmark();
    }

    initTechIntro() {
        const section = document.querySelector(".no-tech-intro");
        if (!section) return;

        const bar = section.querySelector(".no-tech-intro__bar");
        const razor = section.querySelector(".no-tech-intro__image");

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top center",
                toggleActions: "play none none reverse",
                duration: 1,
                ease: "power3.out",
            },
        });

        tl.to(razor, {
            scale: 1,
            opacity: 1,
        }).to(bar, {
            width: "100%",
        });
    }

    history() {
        console.log("[AboutPage] history()");
        const section = document.querySelector(".no-history-intro");
        if (!section) return;

        const introTop = section.querySelector(".no-history-intro__top");
        const logo = section.querySelector(".no-history-intro__logo");
        const overlay = section.querySelector(".no-history-intro__overlay");
        const list = section.querySelector(".no-history-intro__list");
        const items = section.querySelectorAll(".no-history-intro__item");
        const content = section.querySelector(".no-history-intro__content");

        if (!logo || !overlay || !list || !items.length) return;

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: introTop,
                start: "top top",
                end: "+=200%",
                scrub: 1,
                pin: true,
            },
        });

        // 1. Logo scales up massively (0% - 30% of scroll)
        tl.to(
            logo,
            {
                scale: 10,
                ease: "power2.in",
            },
            0
        );

        // 2. Black overlay fades in as logo scales (20% - 40% of scroll)
        tl.to(
            overlay,
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            0.2
        );

        tl.to(
            content,
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            0.3
        );

        // 3. Logo fades out (30% - 45% of scroll)
        tl.to(
            logo,
            {
                opacity: 0,
                ease: "power2.out",
            },
            0.3
        );

        // 4. Content slides up from bottom (50% - 100% of scroll)
        tl.to(
            list,
            {
                y: 0,
                opacity: 1,
                ease: "power2.out",
            },
            0.5
        );

        // 5. Fade out overlay to reveal content (60% - 80% of scroll)
        tl.to(
            overlay,
            {
                opacity: 0,
                ease: "power2.inOut",
            },
            0.6
        );

        // 6. Animate individual items with stagger
        tl.to(
            items,
            {
                opacity: 1,
                y: 0,
                stagger: 0.1,
                ease: "power3.out",
            },
            0.7
        );
    }

    historyTrack() {
        console.log("[AboutPage] historyTrack()");
        const trackSwiper = document.querySelector(".no-history-track__swiper");
        if (!trackSwiper) return;

        new Swiper(trackSwiper, {
            slidesPerView: 4,
            spaceBetween: 24,
            scrollbar: {
                el: trackSwiper.querySelector(".no-history-track__scrollbar"),
                draggable: true,
            },
            navigation: {
                nextEl: ".no-history-track__button--next",
                prevEl: ".no-history-track__button--prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 24,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
        });
    }

    initWordmark() {
        const section = document.querySelector(".no-brand-mark__space");
        if (!section) return;

        const svg = section.querySelector("svg");
        if (!svg) return;

        const vb = (svg.getAttribute("viewBox") || "0 0 0 0")
            .split(/\s+/)
            .map(Number);
        const vbX = vb[0] || 0,
            vbY = vb[1] || 0,
            vbW = vb[2] || svg.clientWidth || 0,
            vbH = vb[3] || svg.clientHeight || 0;

        let defs = svg.querySelector("defs");
        if (!defs) {
            defs = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "defs"
            );
            svg.insertBefore(defs, svg.firstChild);
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top center",
                toggleActions: "play none none reverse",
            },
        });

        const drawTargets = [];
        const labelPairs = [];

        const strokePaths = Array.prototype.slice.call(
            svg.querySelectorAll("path[stroke]")
        );
        strokePaths.forEach((p, i) => {
            const stroke = p.getAttribute("stroke");
            if (!stroke || stroke === "none") return;

            const length = p.getTotalLength();
            const dash = p.getAttribute("stroke-dasharray");
            const hasDash = dash && dash !== "0" && dash !== "none";

            if (!hasDash) {
                gsap.set(p, {
                    strokeDasharray: length,
                    strokeDashoffset: length,
                });
                drawTargets.push(p);
                return;
            }

            const maskId = "drawmask_" + i + "_" + Date.now();
            const mask = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "mask"
            );
            mask.setAttribute("id", maskId);
            mask.setAttribute("maskUnits", "userSpaceOnUse");
            mask.setAttribute("x", vbX);
            mask.setAttribute("y", vbY);
            mask.setAttribute("width", vbW);
            mask.setAttribute("height", vbH);

            const mp = p.cloneNode(true);
            mp.removeAttribute("stroke-dasharray");
            mp.removeAttribute("stroke-dashoffset");
            mp.setAttribute("stroke", "#fff");
            mp.setAttribute("fill", "none");

            const sw = p.getAttribute("stroke-width");
            if (sw) mp.setAttribute("stroke-width", sw);
            const cap = p.getAttribute("stroke-linecap");
            if (cap) mp.setAttribute("stroke-linecap", cap);
            const join = p.getAttribute("stroke-linejoin");
            if (join) mp.setAttribute("stroke-linejoin", join);

            mask.appendChild(mp);
            defs.appendChild(mask);

            p.setAttribute("mask", "url(#" + maskId + ")");

            gsap.set(mp, { strokeDasharray: length, strokeDashoffset: length });
            drawTargets.push(mp);
        });

        const labelFillPaths = Array.prototype.slice
            .call(svg.querySelectorAll("path[fill]"))
            .filter((p) => {
                const fill = (p.getAttribute("fill") || "").toLowerCase();
                const stroke = (p.getAttribute("stroke") || "").toLowerCase();
                if (stroke && stroke !== "none") return false;
                if (!fill || fill === "none") return false;
                if (fill === "black" || fill === "#000" || fill === "#000000")
                    return false;
                if (fill !== "#e10600") return false;
                return true;
            });

        labelFillPaths.forEach((p, i) => {
            const fill = p.getAttribute("fill") || "#E10600";
            const fillOp = p.getAttribute("fill-opacity");
            const overId = "labelStroke_" + i + "_" + Date.now();

            const strokeOnly = p.cloneNode(true);
            strokeOnly.setAttribute("id", overId);
            strokeOnly.setAttribute("fill", "none");
            strokeOnly.setAttribute("stroke", fill);
            if (fillOp) strokeOnly.setAttribute("stroke-opacity", fillOp);
            strokeOnly.setAttribute("stroke-width", "2");
            strokeOnly.setAttribute("stroke-linecap", "round");
            strokeOnly.setAttribute("stroke-linejoin", "round");

            p.style.opacity = "0";

            const parent = p.parentNode;
            parent.insertBefore(strokeOnly, p.nextSibling);

            const length = strokeOnly.getTotalLength();
            gsap.set(strokeOnly, {
                strokeDasharray: length,
                strokeDashoffset: length,
            });

            drawTargets.push(strokeOnly);
            labelPairs.push({ fillPath: p, strokePath: strokeOnly });
        });

        tl.to(drawTargets, {
            strokeDashoffset: 0,
            ease: "power3.out",
            duration: 1.2,
        });

        if (labelPairs.length) {
            tl.to(
                labelPairs.map((x) => x.fillPath),
                { opacity: 1, duration: 0.25, ease: "none" },
                ">-0.15"
            );
            tl.to(
                labelPairs.map((x) => x.strokePath),
                { opacity: 0, duration: 0.2, ease: "none" },
                "<"
            );
        }
    }
}
